import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import logo from '../../../img/logo rio verde pdf.png';

// Função para formatar a quilometragem
const formatKm = (km) => {
  if (isNaN(km) || km === null) return '0 km';
  return parseFloat(km).toLocaleString('pt-BR') + ' km';
};

// A função agora aceita um segundo argumento: as colunas selecionadas
const generateFleetReport = (vehicles, selectedColumns) => {
  const doc = new jsPDF('l', 'mm', 'a4');
  
  const pageWidth = doc.internal.pageSize.getWidth();
  const margin = 15;
  
  // --- Cabeçalho Padrão ---
  doc.addImage(logo, 'PNG', margin, 10, 40, 24);
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(22);
  doc.setTextColor(30, 41, 59);
  doc.text('Relatório Personalizado da Frota', pageWidth / 2, 20, { align: 'center' });
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(10);
  doc.setTextColor(100, 116, 139);
  doc.text(`Total de Veículos no Relatório: ${vehicles.length}`, pageWidth / 2, 27, { align: 'center' });

  // Mapeamento de chaves de dados para cabeçalhos de coluna
  const columnMapping = {
    placa: { header: "Placa", dataKey: "placa" },
    marca: { header: "Marca", dataKey: "marca" },
    modelo: { header: "Modelo", dataKey: "modelo" },
    anoModelo: { header: "Ano", dataKey: "anoModelo" },
    tipoVeiculo: { header: "Tipo", dataKey: "tipoVeiculo" },
    quilometragem: { header: "KM", dataKey: "quilometragem", format: formatKm },
    status: { header: "Status", dataKey: "status" },
  };

  // Filtra as colunas que foram selecionadas (cujo valor é true)
  const activeColumnKeys = Object.keys(selectedColumns).filter(key => selectedColumns[key]);
  
  const tableColumn = activeColumnKeys.map(key => columnMapping[key].header);
  const tableRows = [];

  vehicles.forEach(vehicle => {
    const vehicleData = activeColumnKeys.map(key => {
        const columnDef = columnMapping[key];
        const value = vehicle[columnDef.dataKey];
        // Aplica formatação se existir
        return columnDef.format ? columnDef.format(value) : value;
    });
    tableRows.push(vehicleData);
  });
  
  if (tableColumn.length === 0) {
      // Evita erro caso nenhuma coluna seja selecionada
      doc.text("Nenhuma coluna foi selecionada para o relatório.", margin, 50);
  } else {
      doc.autoTable({
        head: [tableColumn],
        body: tableRows,
        startY: 40,
        theme: 'striped',
        styles: {
          font: 'helvetica',
          fontSize: 9,
          cellPadding: 3,
          valign: 'middle',
        },
        headStyles: {
          fillColor: [241, 245, 249],
          textColor: [30, 41, 59],
          fontStyle: 'bold',
          fontSize: 8.5,
        },
        // O dimensionamento automático de colunas funciona bem aqui
        columnStyles: { }, 
        didDrawPage: (data) => {
          // Rodapé
          const pageHeight = doc.internal.pageSize.getHeight();
          doc.setFontSize(8);
          doc.setTextColor(100, 116, 139);
          doc.text(
            `Gerado em: ${new Date().toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' })}`, 
            margin, 
            pageHeight - 10
          );
          doc.text(
            `Página ${data.pageNumber}`, 
            pageWidth - margin, 
            pageHeight - 10, 
            { align: 'right' }
          );
        },
      });
  }

  // --- Download do PDF ---
  const date = new Date().toLocaleDateString('pt-BR').replace(/\//g, '-');
  doc.save(`Relatorio_Frota_Personalizado_${date}.pdf`);
};

export default generateFleetReport;